<template>
  <slide1 class="mb-33.75"/>
  <slide2 class="mb-25"/>
  <slide3 class="mb-25"/>
  <slide4 class="mb-25"/>
  <slide5 class="mb-25"/>
  <slide6 class="mb-25"/>
  <slide7 />

</template>

<script>
import slide1 from "@/components/mobile/main/slide1";
import slide2 from "@/components/mobile/main/slide2";
import slide3 from "@/components/mobile/main/slide3";
import slide4 from "@/components/mobile/main/slide4";
import slide5 from "@/components/mobile/main/slide5";
import slide6 from "@/components/mobile/main/slide6";
import slide7 from "@/components/mobile/main/slide7";

export default {
  name: "main",
  components:{
    slide1,
    slide2,
    slide3,
    slide4,
    slide5,
    slide6,
    slide7
  }
};
</script>

<style scoped>

</style>